
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
  HttpInterceptor,

} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';



@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
  ) { }
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {

    request = request.clone({
      withCredentials: true,
      headers: request.headers
        .set('Accept', 'application/json, text/plain, text/html')
        .set('X-App-Type', 'admin')
    });


    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.error.msg) {
          if (error.status == 401 || error.error.msg == 'notLoggedIn') {
            this.router.navigate(['login']);
            return throwError(() => (error))
          } else if (error.status == 429) {
            alert('Too many requests, please try again later');
            return throwError(() => (error))
          } else
            return throwError(() => (error))
        }

        return throwError(() => (error))

      })
    );
  }

}
